import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function ListXMark({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM15.5298 16.4702L12 12.9405L8.47024 16.4703L7.52979 15.5298L11.0596 12L7.52979 8.47024L8.47024 7.52979L12 11.0596L15.5298 7.52981L16.4702 8.47026L12.9405 12L16.4702 15.5298L15.5298 16.4702Z"
        fill={iconColor}
      />
    </Svg>
  );
}
